import React, { useEffect, useState } from "react";
import useDataLoader2 from "../../hooks/useDataLoader2";
import Axios from "../../utils/axios";
import CatalogTableC from "../../components/Catalogs/CatalogTableC";
import BackgroundComponent from "../../components/Layout/BackgroundProfile/BackgroundProfile";
import aopRankingBg from "../../../src/assets/images&icons/aopRankingBg.jpeg";
import CatalogTitle from "../../components/Moleculas/Catalog Text/CatalogTitle";
import ShapeEdit from "../../components/Atomos/Icons/ShapeEdit";
import { UseFirmList } from "../../hooks/Catalogs/useFirm";
import { defaultPageSize } from "../../utils/const";
import Filters, { IFilterData } from "../../components/Catalogs/Filters/Filters";
import PaginatedTable from "../../components/Organismos/Table/PaginatedTable";
import PersistentLink from "../../components/Moleculas/PersistentLink";
import { exportAllDataLoader2 } from "../../utils/exportAllDataLoader2";

const AopRankingModule: React.FC = ({ ...props }) => {
  const axios = new Axios();
  const [aopData, setAopData] = useState<any>([]);
  const { firmData } = UseFirmList();
  const endpoint = '/AOPRanking';

  const { 
    data, 
    totalCount, 
    fetchData, 
    setFilter, 
    sort, 
    setSort, 
    pagination, 
    setPagination,
    filter,
    inputFilters,
    setInputFilters
  } = useDataLoader2<any>({
    endpoint,
    defaultPageSize,
  });

  const columnsDef = React.useMemo(() => [
    { 
      id: "count", 
      header: "#", 
      enableSorting: false,
      cell: ({ rowIndex }: { rowIndex: number; row: any; value: any }) => (
        <p>{rowIndex + 1 + pagination.pageIndex * pagination.pageSize}</p>
      )
    },
    { id: "person", header: "Name" },
    { id: "firm", header: "Firm" },
    { id: "rank_1", header: "Rank 1" },
    { id: "rank_2", header: "Rank 2" },
    { id: "rank_3", header: "Rank 3" },
    { id: "rank_4", header: "Rank 4" },
    {
      id: "edit",
      header: "Edit",
      enableSorting: false,
      cell: ({ row }: { rowIndex: number; row: any; value: any }) => (
        <PersistentLink
          className="edit"
          to={`Edit/${row.id}`}
          state={row}
          persistingData={{
            pagination,
            sort,
            filter, 
            inputFilters, 
          }}
        >
          Edit
          <div className="editsvg">
            <ShapeEdit />
          </div>
        </PersistentLink>
      ),
    },
  ], [pagination.pageIndex, pagination.pageSize, sort, filter, inputFilters, firmData]);

  useEffect(() => {
    if (data) {
      setAopData(data)
    }
  },[data]);

  const filtersData: IFilterData[] = React.useMemo(() => [
    {
      name: "Name",
      type: "text",
      comparison: "CONTAINS",
    },
    {
      name: "Firm",
      objectData: firmData?.map((f: any) => ({id:f.id, name: f.name})) || [],
    },
  ], [firmData]);

  return (
    <>
      <BackgroundComponent image={aopRankingBg} />
        <CatalogTableC
          route={"AOPRANKING"}
          catalogName="Rankings"
          totalCount={totalCount}
          noNewCatalog
        >
          <Filters
            filtersData={filtersData} 
            filterValues={inputFilters}
            setFilterValues={setInputFilters} 
            Search={() => fetchData()}
            clearSelections={() => fetchData(true)}
            setValueForQuery={setFilter}
          />
          <PaginatedTable
            data={aopData || []}
            columnsDef={columnsDef}
            sorting={sort}
            onSortingChange={setSort}
            totalCount={totalCount || 0}
            pagination={pagination}
            onPaginationChange={setPagination}
            endpoint={endpoint}
            onExportAll={() =>
              exportAllDataLoader2<any>({
                endpoint,
                filter,
                sort,
                pageSize: 1000,
              })
            }
          />
        </CatalogTableC>
    </>
  );
};

export default AopRankingModule;
